import styles from "../assets/styles/AskStar.module.css";
import AskStarLoading from "../components/AskStarLoading";
import AskStarError from "../components/AskStarError";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import AskStarBackground from "../assets/images/AskStar/AskStarBackground.png";
import TvnLogo from "../assets/images/AskStar/TvnLogo.png";
import AskStarLogo from "../assets/images/AskStar/AskStarLogo.png";
import Header from "../assets/images/AskStar/Header.png";
import LetterBackground from "../assets/images/AskStar/LetterBackground.png";
import SaveButton from "../assets/images/AskStar/SaveButton.png";
import EventHeader from "../assets/images/AskStar/EventHeader.png";
import EventInfo from "../assets/images/AskStar/EventInfo.png";
import EventButton from "../assets/images/AskStar/EventButton.png";

axios.defaults.timeout = 30000;

export default function AskStar() {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [ticketId, setTicketId] = useState("");
  const [searchParams] = useSearchParams();
  const [letterContent, setLetterContent] = useState("");
  const [imageData, setImageData] = useState("");

  useEffect(() => {
    // setIsLoading(true);
    // setIsError(false);

    // const getTicketData = async () => {
    //   let ticketId = searchParams.get("ticketId");
    //   let f_textarea = searchParams.get("f_textarea");
    //   let f_to = searchParams.get("f_to");

    //   if ((!ticketId || ticketId === "") && f_textarea && f_to) {
    //     sendContentToServer(f_textarea, f_to);
    //   } else if (ticketId && !f_textarea && !f_to) {
    //     console.log("getting result from server");
    //     getResultFromServer(ticketId);
    //   } else {
    //     console.log("no ticketId or content");
    //     setIsLoading(false);
    //     setIsError(true);
    //   }
    // };
    // getTicketData();
    setIsError(true);
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && letterContent) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = LetterBackground;
      img.onload = () => {
        const viewportWidth = window.innerWidth;
        const maxWidth = 390;
        const imageWidth = Math.min(viewportWidth * 0.8, maxWidth);
        const imageHeight = (imageWidth / img.width) * img.height;

        canvas.width = imageWidth;
        canvas.height = imageHeight;
        ctx.drawImage(img, 0, 0, imageWidth, imageHeight);

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const font = new FontFace("Sujeong", 'url("Sujeong.otf")');
        font
          .load()
          .then(function (loadedFont) {
            document.fonts.add(loadedFont);
            ctx.font = "50px Sujeong";
            ctx.fillStyle = "black";

            drawTextBox(ctx, letterContent, 140, 280, canvas.width - 280, 1.4);

            const base64Image = canvas.toDataURL("image/png");
            setImageData(base64Image);
          })
          .catch(function (error) {
            console.error("Font loading failed:", error);
          });
      };
    }
  }, [isLoading, isError, letterContent]);

  const sendContentToServer = (f_textarea, f_to) => {
    setIsLoading(true);

    const data = {
      content: f_textarea,
      name: f_to,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .post(process.env.REACT_APP_ASK_STAR_API_URL, data, config)
      .then((res) => {
        setIsLoading(false);
        setIsError(false);

        window.location.href = `/ask-star?ticketId=${res.data.ticketId}`;
      })
      .catch((err) => {
        setIsError(true);
        setIsLoading(false);
        console.log(err);
      });
  };

  const getResultFromServer = (ticketId) => {
    setTicketId(searchParams.get("ticketId").toString());

    const data = {
      ticketId: ticketId,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .post(process.env.REACT_APP_ASK_STAR_API_URL, data, config)
      .then((res) => {
        if (res.data.answer !== "") {
          setLetterContent(res.data.answer);
        }

        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
        console.log(err);
      });
  };

  const moveToEventPage = () => {
    window.open("https://www.instagram.com/p/DDnycyity_P", "_blank");
  };

  const drawTextBox = (ctx, text, x, y, fieldWidth, spacing) => {
    var line = "";
    var fontSize = parseFloat(ctx.font);
    var currentY = y;

    for (var i = 0; i < text.length; i++) {
      var tempLine = line + text[i];
      var tempWidth = ctx.measureText(tempLine).width;

      if (tempWidth < fieldWidth && text[i] != "\n") {
        line = tempLine;
      } else {
        ctx.fillText(line, x, currentY);
        if (text[i] != "\n") line = text[i];
        else line = "";
        currentY += fontSize * spacing;
      }
    }
    ctx.fillText(line, x, currentY);
  };

  return (
    <div className={styles.background}>
      <div className={styles.backgroundImage} style={{ pointerEvents: "none" }}>
        <img src={AskStarBackground} alt="AskStarBackground" />
      </div>

      <div className={styles.content}>
        <img src={TvnLogo} alt="tvnLogo" className={styles.tvnLogo} />
        <img
          src={AskStarLogo}
          alt="askStarLogo"
          className={styles.askStarLogo}
        />

        <img src={Header} alt="header" className={styles.header} />

        {isLoading ? (
          <AskStarLoading />
        ) : isError ? (
          <AskStarError />
        ) : (
          <div>
            <div id="letterContainer" className={styles.letterContainer}>
              <img src={imageData} className={styles.letterCanvas} />
            </div>

            <img
              className={styles.saveButton}
              src={SaveButton}
              alt="saveButton"
            />
          </div>
        )}

        <div className={styles.eventContainer}>
          <img
            src={EventHeader}
            alt="eventHeader"
            className={styles.eventHeader}
          />
          <img src={EventInfo} alt="eventInfo" className={styles.eventInfo} />
          <div onClick={() => moveToEventPage()} className={styles.eventButton}>
            <img src={EventButton} alt="eventButton" />
          </div>
        </div>
      </div>
    </div>
  );
}
